import { AnimatePresence } from 'framer-motion';
import { useMutationModalContext } from '../../contexts/MutationModalProvider';
import ConsentModal from '../CommonComps/Modals/ConsentModal';
import CreateEditReminderModal from '../CommonComps/Modals/CreateEditReminderModal';

const ReminderMutationModals = () => {
  // integration of context hooks here
  const {
    showUpdateModal,
    setShowUpdateModal,
    showDeleteModal,
    setShowDeleteModal,
  } = useMutationModalContext();

  // handler function to delete reminder declared here
  const deleteReminderHandler = async () => {};

  // rendering reminder mutation modals section component here
  return (
    <section>
      <AnimatePresence initial={false} mode='wait' onExitComplete={() => null}>
        {showUpdateModal && (
          <CreateEditReminderModal
            title='update'
            handleModalClose={() => setShowUpdateModal(false)}
          />
        )}
      </AnimatePresence>

      <AnimatePresence initial={false} mode='wait' onExitComplete={() => null}>
        {showDeleteModal && (
          <ConsentModal
            titleText='Are you sure?'
            subTitle={
              <>
                Are you sure you want to delete this reminder? Once you delete
                it, you can not recover it.
              </>
            }
            isLoading={false}
            yesBtnTxt='Yes'
            yesBtnVariant='danger'
            noBtnTxt='No'
            noBtnVariant='success'
            mutationHandler={deleteReminderHandler}
            handleModalClose={() => setShowDeleteModal(false)}
          />
        )}
      </AnimatePresence>
    </section>
  );
};

export default ReminderMutationModals;
